import { useEffect, useState } from "react";

export default function SearchesAdmin({ api }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data: d } = await api.get("/admin/searches");
        setData(d);
      } catch (e) { setData({ top: [], zero: [] }); }
      finally { setLoading(false); }
    })();
  }, [api]);

  if (loading) return <p className="text-[#6E6E6E]">Loading searches…</p>;

  const Table = ({ title, rows, empty, cols }) => (
    <div className="border-2 border-[#1E1E1E] bg-white" data-testid={`searches-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="px-4 py-3 border-b-2 border-[#1E1E1E] bg-[#1E1E1E] text-[#F3F1EC] font-head uppercase tracking-wide text-sm">{title}</div>
      {rows.length === 0 ? (
        <p className="px-4 py-6 text-[#6E6E6E] text-sm">{empty}</p>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[#6E6E6E] border-b border-[#D3CFC0]">
              <th className="px-4 py-2 font-semibold">Query</th>
              {cols.map((c) => <th key={c} className="px-4 py-2 font-semibold text-right">{c}</th>)}
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={i} className="border-b border-[#EDE8DD]">
                <td className="px-4 py-2 text-[#1E1E1E]">{r.q}</td>
                <td className="px-4 py-2 text-right text-[#1E1E1E] font-semibold">{r.count}</td>
                {"avg_results" in r && <td className="px-4 py-2 text-right text-[#6E6E6E]">{r.avg_results}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );

  return (
    <div className="space-y-8" data-testid="searches-admin">
      <p className="text-[#6E6E6E] text-sm">What people are searching for (last 30 days). Zero-result searches are content ideas.</p>
      <Table title="Top Searches" rows={data.top} cols={["Count", "Avg results"]} empty="No searches logged yet." />
      <Table title="Zero-Result Searches" rows={data.zero} cols={["Count"]} empty="No empty searches — nice." />
    </div>
  );
}
